module.exports = __webpack_public_path__ + "media/images/curriculum/curriculum-273f4ca41e1d767347029370d12332e3.png";